/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { workspacesRemoveById } from "../../funcs/workspacesRemoveById.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .DeleteApiLeadScraperMicroserviceApiV1WorkspaceIdRequest$inboundSchema,
};

export const tool$workspacesRemoveById: ToolDefinition<typeof args> = {
  name: "workspaces_remove-by-id",
  description: `Delete a workspace

Deletes a specific workspace`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await workspacesRemoveById(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
